import React from "react";
import { typography, surfaces, borders, textColors, interactive } from "../../../design-system/tokens";

const DEFAULT_CHOICES = [
  { value: "none", label: "None" },
  { value: "blur-xs", label: "Extra Small" },
  { value: "blur-sm", label: "Small" },
  { value: "blur-md", label: "Medium" },
  { value: "blur-lg", label: "Large" },
  { value: "blur-xl", label: "Extra Large" },
  { value: "blur-2xl", label: "2X Large" },
  { value: "blur-3xl", label: "3X Large" },
];

export default function BlurField({ label, help, value, onChange, choices, infoText }) {
  const opts = Array.isArray(choices) && choices.length
    ? choices.map((c) => ({ value: c.value, label: c.label }))
    : DEFAULT_CHOICES;

  const normalized = value || "none";

  return (
    <div className="field-wrapper">
      {label && (
        <label className={`block mb-2 ${typography.label} ${textColors.secondary}`}>
          {label}
        </label>
      )}

      {/* Tighter grid: minmax 60px allows ~4-5 items per row on standard widths */}
      <div className="grid gap-2" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(60px, 1fr))" }}>
        {opts.map((opt) => {
          const selected = normalized === opt.value;
          // Map "none" to "blur-none" for the class, others are valid classes in this project
          const blurClass = opt.value === "none" ? "blur-none" : opt.value;

          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={`flex flex-col items-center p-2 border rounded-lg transition-all ${
                selected 
                  ? `${interactive.selectedBg} ${interactive.selectedBorder} shadow-sm` 
                  : `${borders.default} ${surfaces.tertiary} ${surfaces.hover}`
              }`}
              title={opt.label}
            >
              {/* Visual Preview: Smaller gradient circle (w-7 h-7 = 28px) */}
              <div className="w-full h-9 flex items-center justify-center mb-1">
                <div
                  className={`w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 ${blurClass}`}
                />
              </div>
              <span className={`text-[10px] leading-tight ${selected ? "text-white" : textColors.primary} text-center break-words w-full`}>
                {opt.label}
              </span>
            </button>
          );
        })}
      </div>

      {help && (
        <div className={`mt-2 ${typography.caption} ${textColors.tertiary}`}>
          {help}
        </div>
      )}
    </div>
  );
}
